import { render, staticRenderFns } from "./zhuanti-minyingjingji.vue?vue&type=template&id=7fe0fcb5&"
import script from "./zhuanti-minyingjingji.vue?vue&type=script&lang=js&"
export * from "./zhuanti-minyingjingji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports